import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from "react-toastify";
import { SBAComboBox, SBADropDown, SBAMultiSelect } from '../../UiComponents/SBADropDown';
import {
    getLiquiditySummaryData,
    getAllFamilies,
    getPortfoliosByFamily,
    getLiquidityScheduleReport,
    getPDFLiquidityReport
} from "../../../config/apiConfig";
import { sbaAxios } from '../../utils/sbaAxios';
import { SBDatePicker } from '../../UiComponents/SBDatePicker';
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';
import { useRef } from 'react';
import { useMemo } from 'react';
import { Chart, ChartLegend, ChartTitle, ChartCategoryAxis, ChartCategoryAxisItem, ChartValueAxis, ChartValueAxisItem, ChartSeries, ChartSeriesItem } from '@progress/kendo-react-charts';
import { Modal } from "react-bootstrap";
import { LoadingScreen } from '../../UiComponents/LoadingComponent';
export const LiquidityTab = () => {
    const solutionList = [
        { solutionId: 0, solutionName: "Quickest" },
        { solutionId: 1, solutionName: "Cheapest" },
        { solutionId: 2, solutionName: "Both" }
    ];

    const frequencyList = [
        { frequencyId: 1, frequencyName: "Monthly" },
        { frequencyId: 2, frequencyName: "Quarterly" },
        { frequencyId: 3, frequencyName: "Annual" },
    ];

    const viewList = [
        { viewId: 0, viewName: "Strategy View" },
        { viewId: 1, viewName: "Schedule View" }
    ];


    const gridRefSchedule = useRef();
    const gridRefStrategyQuick = useRef();
    const gridRefStrategyCheap = useRef();
    

    const [familyList, setFamilyList] = useState([]);
    const [selectedFamily, setSelectedFamily] = useState(null);
    const [selectedFamilyId, setSelectedFamilyId] = useState(0);
    const [portfolioList, setPortfolioList] = useState([]);
    const [selectedPortfolio, setSelectedPortfolio] = useState([]);
    const [liquidityDate, setLiquidityDate] = useState(new Date());
    // const [endMonth, setEndMonth] = useState(new Date());
    const [solution, setSolution] = useState(solutionList[0]);
    const [frequency, setFrequency] = useState(frequencyList[0]);
    const [view, setView] = useState(viewList[0]);


    const [percentTotal, setPercentTotal] = useState(true);
    const [gridMode, setGridMode] = useState('Tree');
    const [includeCashFlow, setIncludeCashFlow] = useState(false);
    const [maxNumOfMonthCashFlow, setMaxNumOfMonthCashFlow] = useState(localStorage.getItem('maxNumOfMonthCashFlow') || 36);
    const [inputValue, setInputValue] = useState(localStorage.getItem('maxNumOfMonthCashFlow') || 36);
    const [showModel, setShowModel] = useState(false);

    const [strategyViewAPI,setStrategyViewAPI]=useState([]);
    const [scheduledViewAPI,setScheduledViewAPI]=useState([]);

    const [scheduledViewData, setScheduledViewData] = useState([]);
    const [scheduledViewCol, setScheduledViewCol] = useState([]);

    const [cheapStartegyViewData, setCheaapStartegyViewData] = useState([]);
    const [cheapStartegyViewCol, setCheapStartegyViewCol] = useState([]);

    const [quickStartegyViewData, setQuickStartegyViewData] = useState([]);
    const [quickStartegyViewCol, setQuickStartegyViewCol] = useState([]);


    const [chartDate,setChartDate]=useState([]);
    const [chartCumulativepercent,setChartCumulativepercent]=useState([]);


    const scheduledViewDataAssetTotal=scheduledViewData.filter(item => item?.mode == "pinned").filter(item => item.TotalorPercetage == "TotalorPecentage") || [];
    const cheapStartegyViewDataAssetTotal=cheapStartegyViewData.filter(item => item?.mode == "pinned").filter(item => item.TotalorPercetage == "TotalorPecentage") || [];
    const quickStartegyViewDataAssetTotal=quickStartegyViewData.filter(item => item?.mode == "pinned").filter(item => item.TotalorPercetage == "TotalorPecentage") || [];

    const [isGridLoading, setIsGridLoading] = useState(true);
    const [isImageButton, setIsImageButton] = useState(localStorage.getItem('isImageButton') === '1');

    useEffect(() => {
        const fetchFamilies = async () => {
            try {
                const list = await sbaAxios({
                    url: getAllFamilies
                });
                setFamilyList(list);
            }
            catch (e) {
                setFamilyList([]);
            }
        };
        fetchFamilies();
    }, []);


    useEffect(() => {
        setTimeout(() => {
            setIsGridLoading(false);
        }, 1000);
    }, [isGridLoading]);

    useEffect(() => {
        const fetchPortfoliosByFamily = async () => {
            try {
                const list = await sbaAxios({
                    url: getPortfoliosByFamily,
                    params: {
                        familyId: selectedFamilyId
                    }
                });
                setPortfolioList(list);
                setSelectedPortfolio(list);
            }
            catch (e) {
                setPortfolioList([]);
                setSelectedPortfolio([]);
            }
        };
        if (selectedFamilyId !== 0) {
            fetchPortfoliosByFamily();
        }
    }, [selectedFamilyId]);
    const getDataPath = useMemo(() => {
        return (data) => {
            if (data.AssetId && Array.isArray(data?.StrategyName) && data?.PortfolioAbbrev) {
                const lastIndex = data.StrategyName.length - 1;
                if (lastIndex >= 0) {
                    //data.StrategyName[lastIndex] = data.StrategyName[lastIndex] + "***" + data.PortfolioAbbrev;
                    data.StrategyName[lastIndex] = data.AssetName + "***" + data.PortfolioAbbrev;
                }
            }
            return data?.StrategyName;
        };
    }, []);


    function exportToExcel() {
        if(view.viewId==1)
        {
            const allColumns = gridRefSchedule?.current?.columnApi?.getAllColumns();
            const exportColumns = allColumns.filter(col => !col.userProvidedColDef?.suppressExcelExport);
            gridRefSchedule.current.api.exportDataAsExcel({
                fileName: 'Liquidity_Scheduled.xlsx',
                processCellCallback: (params) => {
                  let value = params.value;
                  const colId = params.column?.colDef?.cellClass || "";
                    if (params?.data?.mode == "pinned") {
                       
                        if (params?.data?.TotalorPercetage == "Percentage")
                             params.cellClass = "percentageFormat";
                        else
                        params.cellClass = "currencyFormat";
                    }
                    else {
                        params.cellClass = colId;
                    }
                  return value;
                },
                columnKeys: exportColumns,
              });
        }
        else if(view.viewId==0)
        {
            if( (solution.solutionId==1 || solution.solutionId==2))
            {
                const cheapAllColumns = gridRefStrategyCheap?.current?.columnApi?.getAllColumns();
                const cheapExportColumns = cheapAllColumns.filter(col => !col.userProvidedColDef?.suppressExcelExport);
                gridRefStrategyCheap.current.api.exportDataAsExcel({
                    fileName: 'Liquidity_Cheap.xlsx',
                    processCellCallback: (params) => {
                      let value = params.value;
                      const colId = params.column?.colDef?.cellClass || "";
                        if (params?.data?.mode == "pinned") {
                            if (params?.data?.TotalorPercetage == "Percentage")
                                 params.cellClass = "percentageFormat";
                            else
                            params.cellClass = "currencyFormat";
                        }
                        else {
                            params.cellClass = colId;
                        }
                      return value;
                    },
                    columnKeys: cheapExportColumns,
                  });
            }
            if( (solution.solutionId==0 || solution.solutionId==2))
            {

                const quickAllColumns = gridRefStrategyQuick?.current?.columnApi?.getAllColumns();
                const quickExportColumns = quickAllColumns.filter(col => !col.userProvidedColDef?.suppressExcelExport);
                gridRefStrategyQuick.current.api.exportDataAsExcel({
                    fileName: 'Liquidity_Quick.xlsx',
                    processCellCallback: (params) => {
                      let value = params.value;
                      const colId = params.column?.colDef?.cellClass || "";
                        if (params?.data?.mode == "pinned") {
                            if (params?.data?.TotalorPercetage == "Percentage")
                                 params.cellClass = "percentageFormat";
                            else
                            params.cellClass = "currencyFormat";
                        }
                        else {
                            params.cellClass = colId;
                        }
                      return value;
                    },
                    columnKeys: quickExportColumns,
                  });
          }
         
            }
            
           

    };

    const fetchLiquidityData = async () => {
        if(selectedPortfolio.length>0)
        {
            const listStr = selectedPortfolio.map(item => item.EntityId).join(',');
            try {
                const starResponse = await sbaAxios({
                    url: getLiquiditySummaryData,
                    params: {
                        portfolioIdList: listStr,
                        liquidityDate: moment(liquidityDate).format('YYYY-MM-DD'),
                        aggregateToStrategy: false,
                        liquidityFrequencyView: frequency.frequencyId,
                        includeCashFlows: includeCashFlow,
                        maxNrOfMonthForCashFlow: maxNumOfMonthCashFlow
                    }
                });
            
                const schResponse = await sbaAxios({
                    url: getLiquidityScheduleReport,
                    params: {
                        portfolioIdList: listStr,
                        liquidityDate: moment(liquidityDate).format('YYYY-MM-DD'),
                        includeCashFlows: includeCashFlow,
                        maxNrOfMonthForCashFlow: maxNumOfMonthCashFlow
                    }

                });
                
                setChartDate(schResponse);
                setChartCumulativepercent(schResponse?.AssetsTotalLiqCummPercent);


                setIsGridLoading(true);

                setStrategyViewAPI(starResponse);
                setScheduledViewAPI(schResponse);
                console.log(getFormattedData(starResponse,gridMode=='Tree'),'123456')
                setCheaapStartegyViewData(getFormattedData(starResponse,gridMode=='Tree'));
                setCheapStartegyViewCol(getFormattedColumn(starResponse,'Cheap',gridMode=='Tree'));
    
                setQuickStartegyViewData(getFormattedData(starResponse,gridMode=='Tree'));
                setQuickStartegyViewCol(getFormattedColumn(starResponse,'QUICK',gridMode=='Tree'));
    
                setScheduledViewData(getFormattedData(schResponse,gridMode=='Tree'));
                setScheduledViewCol(getFormattedColumn(schResponse,'SCH',gridMode=='Tree'));
            }
            catch (e) {
                toast.error("Error Formatting grid Data");
                console.log(e)
            }
        }
        else {
            toast.error("Please Select any portfolio ");
        }
       
    };

    const autoGroupColumnDef = useMemo(() => {
        return {
            headerName: "Strategy",
            pinned: "left",
            cellRenderer: "agGroupCellRenderer",
            cellRendererParams: (params) => {
                if (gridMode == "Tree") {
                    if (params?.node?.rowPinned === "bottom") {
                        return { innerRenderer: () => params.data?.StrategyName[0] || "" };
                    }
                    else if (params?.data?.StrategyName.length == 2) {
                        return { innerRenderer: () => AssetNameFormatter(params.data?.StrategyName[1]) || "" };

                    }

                    return { suppressCount: true, };
                }

            },
            suppressExcelExport :true,
            editable: false,
            headerClass: "ag-grid-BR",
            useValueFormatterForExport: true,
            minWidth:300
        };
    }, []);

    const ExpandCollapseButton = () => {
        const [expanded, setExpanded] = useState(false);
        const onExpandAll = () => {
            setExpanded(true);
            gridRefSchedule.current?.api.expandAll();
            gridRefStrategyQuick.current?.api.expandAll();
            gridRefStrategyCheap.current?.api.expandAll();
        };
        const onCollapseAll = () => {
            setExpanded(false);
            gridRefSchedule.current?.api.collapseAll();
            gridRefStrategyQuick.current?.api.collapseAll();
            gridRefStrategyCheap.current?.api.collapseAll();
        };
        return (
            <div className="expand-collapse-button"> {!expanded ?
                <button onClick={onExpandAll} disabled={gridMode === 'Flat'} className="p-sm-btn">Expand All</button>
                :
                <button onClick={onCollapseAll} disabled={gridMode === 'Flat'} className="p-sm-btn">Collapse All</button>
            }
            </div>
        );
    };
    const handleSelectedPortfolio = (e) => {
        setSelectedPortfolio(e.value);
    };

    const handleSelectedFamily = (e) => {
        setSelectedFamily(e.value);
        setSelectedFamilyId(e.value?.FamilyId);
    };

    const handleSelectedSolution = (e) => {
        setSolution(e.value);
    };

    const handleSelectedFrequency = (e) => {
        setFrequency(e.value);
    };

    const handleSelectedView = (e) => {
        if (e.value.viewId == 1) {
            setSolution(solutionList[2])
        }
        setView(e.value);
    };

    const handleSettingsSave = () => {
        // Ensure the input value is valid before updating
        if (inputValue >= 1 && inputValue <= 100) {
            setMaxNumOfMonthCashFlow(inputValue);
            localStorage.setItem("maxNumOfMonthCashFlow", inputValue);
            localStorage.setItem("isImageButton", isImageButton ? 1 : 0);
            setShowModel(false);
        } else {
            alert("Please enter a value between 1 and 100.");
        }
    };

    const handlePDFDownload = async () => {
        if (selectedFamily === null) {
            toast.error("Please select a family");
        }
        else {
            try {
                // Convert the selected portfolio to a comma-separated string
                const portfolioIdsString = selectedPortfolio.map(item => item.EntityId).join(',');

                // Format the date as a string
                const formattedDate = moment(liquidityDate).format('MM-DD-YYYY');

                console.log("PortfolioIds:", portfolioIdsString);
                console.log("LiquidityDate:", formattedDate);
                await sbaAxios({
                    url: getPDFLiquidityReport,
                    params: {
                        PortfolioIds: portfolioIdsString,
                        FamilyName: selectedFamily.FamilyName,
                        LiquidityDate: formattedDate,
                        //LiquidityDate:moment(liquidityDate).format('MM/DD/YYYY')
                    },
                    method: 'GET',
                    responseType: 'blob'
                }).then((response) => {
                    // Log the response for debugging purposes
                    console.log('Response:', response);

                    // Ensure the response data is a Blob

                    const blobUrl = window.URL.createObjectURL(response);
                    // Create an anchor element and trigger the download
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.download = 'Liquidity.pdf';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    // Revoke the blob URL to free up memory
                    window.URL.revokeObjectURL(blobUrl);

                })
            }
            catch (e) {
                toast.error('Unable to download');
            }
        }
    };

    const excelStyles = useMemo(() => {
        return [
            {
                id: 'currencyFormat',
                numberFormat: {
                    format: '$#,##0.00',
                },
            },
            {
                id: 'percentageFormat',
                numberFormat: {
                    format: '0.00%',
                },
            },
        ];
    }, []);
    const updateGridMode = () => {
        setIsGridLoading(true);
        const mode = gridMode == 'Tree' ? 'Flat' : 'Tree';
        setGridMode(val => (mode));
        
        
        setCheaapStartegyViewData(getFormattedData(strategyViewAPI,mode=='Tree'));
        setCheapStartegyViewCol(getFormattedColumn(strategyViewAPI,'Cheap',mode=='Tree'));

        setQuickStartegyViewData(getFormattedData(strategyViewAPI,mode=='Tree'));
        setQuickStartegyViewCol(getFormattedColumn(strategyViewAPI,'QUICK',mode=='Tree'));

        setScheduledViewData(getFormattedData(scheduledViewAPI,mode=='Tree'));
        setScheduledViewCol(getFormattedColumn(scheduledViewAPI,'SCH',mode=='Tree'));

        
    };
    return <>
        <div className="container-fluid p-4">
            <div className='row'>
                <div className='col-4 h-75'>
                    <div className='row'>
                        <div className='col-md-10'>
                            <label className='label'>Family</label>
                            <div>
                                <SBAComboBox
                                    className="w-100"
                                    data={familyList}
                                    textField={"FamilyName"}
                                    valueField={"FamilyId"}
                                    value={selectedFamily}
                                    onChange={handleSelectedFamily}
                                    popupSettings={{ className: "modalDD" }}
                                ></SBAComboBox>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-10'>
                            <label className='label'>Portfolio</label>
                            <div>
                                <SBAMultiSelect
                                    className="w-100"
                                    data={portfolioList}
                                    textField={"EntityName"}
                                    valueField={"EntityId"}
                                    value={selectedPortfolio}
                                    onChange={handleSelectedPortfolio}
                                    popupSettings={{ className: "modalDD" }}
                                ></SBAMultiSelect>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-10'>
                            <div className='my-2' style={{ flex: 1 }}>
                                <label className='label'>Frequency</label>
                                <div>
                                    <SBADropDown
                                        data={frequencyList}
                                        textField={"frequencyName"}
                                        valueField={"frequencyId"}
                                        value={frequency}
                                        onChange={handleSelectedFrequency}
                                        popupSettings={{ className: "modalDD" }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-6' style={{ width: '66%' }}>
                            <div className='my-2'>
                                <label className='label'>Liquidity Date</label>
                                <div>
                                    <SBDatePicker
                                        className="w-75"
                                        value={moment(liquidityDate)}
                                        onChange={(newDate) => { setLiquidityDate(newDate) }}
                                    ></SBDatePicker>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-10'>
                            <div className='my-2' style={{ flex: 1 }}>
                                <label className='label'>Views</label>
                                <div>
                                    <SBADropDown
                                        data={viewList}
                                        textField={"viewName"}
                                        valueField={"viewId"}
                                        value={view}
                                        onChange={handleSelectedView}
                                        popupSettings={{ className: "modalDD" }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-10'>
                            <div className='my-2' style={{ flex: 1 }}>
                                <input type='radio' className='percentageTotal' checked={percentTotal} onChange={(e) => { setPercentTotal(val => !val) }} />
                                <label className='label mx-2'>Percentage</label>
                                <input type='radio' className='percentageTotal' checked={!percentTotal} onChange={(e) => { setPercentTotal(val => !val) }} />
                                <label className='label mx-2'>Total</label>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-10'>
                            <div style={{ display: 'flex', alignItems: 'end' }}>
                                <div style={{ flex: 1 }}>
                                    <label className='label'>Solution</label>
                                    <div>
                                        <SBADropDown
                                            disabled={view.viewId == 1}
                                            data={solutionList}
                                            textField={"solutionName"}
                                            valueField={"solutionId"}
                                            value={solution}
                                            onChange={handleSelectedSolution}
                                            popupSettings={{ className: "modalDD" }}
                                        />
                                    </div>
                                </div>
                                <div style={{ marginLeft: '10px', display: 'flex', alignItems: 'center' }}>
                                    <button
                                        type="submit"
                                        className="p-sm-btn"
                                        onClick={() => {
                                            fetchLiquidityData();
                                        }}
                                    >
                                        Go
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-6">
                            <p style={{ display: 'flex', alignItems: 'center', marginTop: '25px', gap: '10px' }}>
                                <input
                                    type="checkbox"
                                    checked={includeCashFlow}
                                    onChange={() => setIncludeCashFlow(!includeCashFlow)}
                                />
                                <label className="label">Include Model</label>
                            </p>
                        </div>
                    </div>
                </div>
                <div className='row col-8 col h-25'>
                    <div class="row detail m-0 p-3">
                        <LiquidityChart liquiditychartdata={chartDate} chartdata={[chartCumulativepercent]} type={solution.solutionName} ></LiquidityChart>
                      </div>
                </div>
            </div>
            <div className='row'>
                <div className='row col-12 h-100'>
                    <div className='d-flex justify-content-between mt-2' >
                        {< div className='d-flex gap-2'>
                            <ExpandCollapseButton /> <button className='p-sm-btn'
                                onClick={() => { updateGridMode() }}>{gridMode == 'Tree' ? 'Expand Flat' : 'Expand Tree'}</button>
                        </div>}
                    </div>
                    {isGridLoading ? <><LoadingScreen /></> : <>
                        {view.viewId == 1 && <>
                            <div className='d-flex justify-content-between mt-2'>
                                <p style={{ marginTop: "10px" }}>Schedule  View</p>
                                <div style={{ display: 'flex' }}>
                                    {isImageButton ?
                                        <i className="fa-solid fa-gear SBA_hand" onClick={() => setShowModel(true)} style={{ marginTop: '10px' }}></i> :
                                        <button className='p-sm-btn' onClick={() => setShowModel(true)}>Settings</button>
                                    }
                                    <span style={{ width: "10px" }}></span>
                                    {
                                        isImageButton ?
                                            <i class="far fa-file-excel SBA_hand" style={{ color: "green", marginTop: '10px' }} 
                                            onClick={
                                                () => { 
                                                    exportToExcel()
                                                }
                                            }
                                            ></i> :
                                            <button
                                                type="submit"
                                                className="p-sm-btn"
                                                style={{
                                                    width: '100px', 
                                                    textAlign: 'center' 
                                                }}
                                                onClick={() => {
                                                     exportToExcel()
                                                }}
                                            >
                                                Export
                                            </button>
                                    }
                                    <span style={{ width: "10px" }}></span>
                                    {isImageButton ?
                                        <i class="far fa-file-pdf SBA_hand" style={{ color: "red", marginTop: '10px' }} onClick={handlePDFDownload}></i> :
                                        <button className='p-sm-btn' onClick={handlePDFDownload}>PDF Download</button>
                                    }
                                </div>
                            </div>
                            <div className="ag-theme-alpine">
                                <AgGridReact
                                    rowData={scheduledViewData.filter(item => item?.mode == "rowData")}
                                    excelStyles={excelStyles}
                                    columnDefs={scheduledViewCol}
                                    pinnedBottomRowData={[...scheduledViewDataAssetTotal,...scheduledViewData.filter(item => item?.mode == "pinned").filter(item => item.TotalorPercetage == (percentTotal ? "Percentage" : "Total"))]}
                                    animateRows={true}
                                    treeData={gridMode == "Tree"}
                                    getDataPath={getDataPath}
                                    autoGroupColumnDef={autoGroupColumnDef}
                                    ref={gridRefSchedule}
                                    defaultColDef={{ flex: 1, resizable: true }}
                                />
                            </div>
                        </>}
                        {view.viewId == 0 &&
                            <>
<>
                            <div className='d-flex justify-content-between mt-2'>
                                <p style={{ marginTop: "10px" }}>Strategy  View</p>
                                <div style={{ display: 'flex' }}>
                                    {isImageButton ?
                                        <i className="fa-solid fa-gear SBA_hand" onClick={() => setShowModel(true)} style={{ marginTop: '10px' }}></i> :
                                        <button className='p-sm-btn' onClick={() => setShowModel(true)}>Settings</button>
                                    }
                                    <span style={{ width: "10px" }}></span>
                                    {
                                        isImageButton ?
                                            <i class="far fa-file-excel SBA_hand" style={{ color: "green", marginTop: '10px' }} 
                                            onClick={
                                                () => { 
                                                    exportToExcel()
                                                }
                                            }
                                            ></i> :
                                            <button
                                                type="submit"
                                                className="p-sm-btn"
                                                style={{
                                                    width: '100px', 
                                                    textAlign: 'center' 
                                                }}
                                                onClick={() => {
                                                     exportToExcel()
                                                }}
                                            >
                                                Export
                                            </button>
                                    }
                                    <span style={{ width: "10px" }}></span>
                                    {isImageButton ?
                                        <i class="far fa-file-pdf SBA_hand" style={{ color: "red", marginTop: '10px' }} onClick={handlePDFDownload}></i> :
                                        <button className='p-sm-btn' onClick={handlePDFDownload}>PDF Download</button>
                                    }
                                </div>
                            </div>
                            {   (solution.solutionId==0 || solution.solutionId==2) &&
                                    <>
                                        <div className="ag-theme-alpine">
                                            <AgGridReact
                                                rowData={quickStartegyViewData.filter(item => item?.mode == "rowData")}
                                                excelStyles={excelStyles}
                                                columnDefs={quickStartegyViewCol}
                                                pinnedBottomRowData={[...quickStartegyViewDataAssetTotal,...quickStartegyViewData.filter(item => item?.mode == "pinned").filter(item => item.TotalorPercetage == (percentTotal ? "Percentage" : "Total") )]}
                                                animateRows={true}
                                                treeData={gridMode == "Tree"}
                                                getDataPath={getDataPath}
                                                autoGroupColumnDef={autoGroupColumnDef}
                                                ref={gridRefStrategyQuick}
                                                defaultColDef={{ flex: 1, resizable: true }}
                                            />
                                        </div>
                                    </>
                            }
                            {   (solution.solutionId==1 || solution.solutionId==2) &&
                                    <>
                                        <div className="ag-theme-alpine">
                                            <AgGridReact
                                                rowData={cheapStartegyViewData.filter(item => item?.mode == "rowData")}
                                                excelStyles={excelStyles}
                                                columnDefs={cheapStartegyViewCol}
                                                pinnedBottomRowData={[...cheapStartegyViewDataAssetTotal,...cheapStartegyViewData.filter(item => item?.mode == "pinned").filter(item => item.TotalorPercetage == (percentTotal ? "Percentage" : "Total"))]}
                                                animateRows={true}
                                                treeData={gridMode == "Tree"}
                                                getDataPath={getDataPath}
                                                autoGroupColumnDef={autoGroupColumnDef}
                                                ref={gridRefStrategyCheap}
                                                defaultColDef={{ flex: 1, resizable: true }}
                                            />
                                        </div>
                                    </>
                            }
                             
                           
                        </>
                            </>}
                    </>}
                </div>
            </div>
        </div>
        <Modal show={showModel} onHide={() => setShowModel(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Liquidity Settings</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div style={{ display: 'flex', alignItems: 'start', gap: '8px' , flexDirection:'column'}}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px'}}>
                <p style={{ marginBottom: '0' }}>Cash Flow aggregation time frame:</p>
                <input
                type="number"
                min="1"
                max="100"
                value={inputValue}
                onChange={(e) => setInputValue(Number(e.target.value))}
                className="form-control"
                style={{ width: '70px' }} // Adjust width as needed
                />
                <p style={{ marginBottom: '0' }}>Months</p>
                </div>
                <div>
                <p style={{ display: 'flex', alignItems: 'center' ,gap:'10px'}}>
                                <input
                                    type="checkbox"
                                    checked={isImageButton}
                                    onChange={() => setIsImageButton(!isImageButton)}
                                />
                                <label className="label">Image buttons</label>
                            </p> 
                </div>
            </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="s-sm-btn mx-1" onClick={() => setShowModel(false)}>
                    Cancel
                </button>
                <button
                    className="p-sm-btn mx-1"
                    onClick={handleSettingsSave}
                >
                    Save
                </button>
            </Modal.Footer>
        </Modal>
        {/* <ToastContainer /> */}
    </>
}
export const LiquidityChart = ({ liquiditychartdata, chartdata, type }) => {

    const dt = liquiditychartdata?.AssetLiqSchedule?.length > 0
        ? liquiditychartdata?.AssetLiqSchedule[0]?.QuickestRedemptions
        : [];
    const uniqueCategories = dt.length > 0
        ? dt.map(item => {
            const formattedDate = new Date(item.RedemptionDate).toLocaleDateString('en-US');
            return formattedDate;
        })
        : [];
    // //Quickest type data
    const quickesttotdt = chartdata?.length > 0
        ? chartdata[0]?.QuickestRedemptions
        : [];
    const chartquickesttotdt = quickesttotdt?.length > 0
        ? quickesttotdt?.map(item => {
            return (item.RedemptionAmount);
        })
        : [];

    //Cheapest type data
    const cheapesttotdt = chartdata?.length > 0
        ? chartdata[0]?.CheapestRedemptions
        : [];
    const chartcheapestdt = cheapesttotdt?.length > 0
        ? cheapesttotdt?.map(item => {
            return (item.RedemptionAmount);
        })
        : [];



    return (
        <>
            <div style={{ height: '400px' }}>
                <Chart>
                    <ChartTitle text={`Liquidity Ladder – ${type} Solution`} />

                    <ChartCategoryAxis>
                        <ChartCategoryAxisItem
                            categories={uniqueCategories}
                            title={{ visible: false }}
                            line={{ visible: false }}

                        />
                    </ChartCategoryAxis>
                    <ChartSeries>
                        {(type === "Quickest" || type === "Both") && (
                            <ChartSeriesItem
                                type="line"
                               data={chartquickesttotdt}
                                color="#05BFDB"
                                tooltip={{ visible: true, format: `{0:p2}` }}
                                axis="primary"
                                name="Quickest"
                            />
                        )}
                        {(type === "Cheapest" || type === "Both") && (
                            <ChartSeriesItem
                                type="line"
                                data={chartcheapestdt}
                                color='#FFA500'
                                tooltip={{ visible: true, format: `{0:p2}` }}
                                axis="primary"
                                name="Cheapest"
                            />
                        )}
                    </ChartSeries>




                    <ChartLegend position="bottom" visible={true} />
                    <ChartValueAxis>
                        <ChartValueAxisItem name="primary" color="#7D7D7D" axisCrossingValue={[0, -100000000000000000, 0, 0]} labels={{ format: '{0:p0}', position: 'right' }} majorGridLines={{ visible: false }} />

                    </ChartValueAxis>
                </Chart>

            </div>
        </>
    )
};
function AssetNameFormatter(params) {
    const starIndex = params?.indexOf('***');
    if (starIndex > 0)
        return params.slice(0, starIndex);
    else
        return params;
};
const getFormattedData = (APIData,isTreeView) => {
    const assetLines = [...APIData?.AssetLiqSchedule || []]
    const staLines = [...APIData?.StrategyLiqSchedule || []]
    const formattedAssetLines = assetLines.map(item => {
        const formattedValues = {};
        formattedValues.StrategyName = [item?.StrategyName, item.AssetName + "***" + item.PortfolioAbbrev];
        formattedValues.Strategy = item?.StrategyName;
        formattedValues.AssetName = item.AssetName;
        formattedValues.PortfolioAbbrev = item.PortfolioAbbrev;
        formattedValues.CurrentPosition = item.MarketValue;
        formattedValues.Weight = item.Weight;
        item.QuickestRedemptions.map(item => {
            formattedValues[item.RedemptionDate + "***" + "Quick"] = item.RedemptionAmount
            formattedValues[item.RedemptionDate + "***" + "QuickIsBooked"] = item.IsBooked
        })
        item.CheapestRedemptions.map(item => {
            formattedValues[item.RedemptionDate + "***" + "Cheap"] = item.RedemptionAmount
            formattedValues[item.RedemptionDate + "***" + "CheapIsBooked"] = item.IsBooked
        });
        formattedValues.mode = "rowData";
        formattedValues.type = "AssetLine";
        return formattedValues;
    });
    const formattedStrategyLines = staLines.map(item => {
        const formattedValues = {};
        formattedValues.StrategyName = [item?.StrategyName];
        formattedValues.AssetName = item.AssetName;
        formattedValues.Strategy = item?.StrategyName;
        formattedValues.PortfolioAbbrev = item.PortfolioAbbrev;
        formattedValues.CurrentPosition = item.MarketValue;
        formattedValues.Weight = item.Weight;
        item?.QuickestRedemptions?.map(item => {
            formattedValues[item.RedemptionDate + "***" + "Quick"] = item.RedemptionAmount
            formattedValues[item.RedemptionDate + "***" + "QuickIsBooked"] = item.IsBooked
            
        })
        item?.CheapestRedemptions?.map(item => {
            formattedValues[item.RedemptionDate + "***" + "Cheap"] = item.RedemptionAmount
            formattedValues[item.RedemptionDate + "***" + "CheapIsBooked"] = item.IsBooked
            
        });
        formattedValues.mode = "rowData";
        formattedValues.type = "strategyLine";
        return formattedValues;
    });
    const AssetTotal = {}
    AssetTotal.StrategyName = ["Total"];
    AssetTotal.Strategy = "Total";
    AssetTotal.AssetName = APIData.AssetsTotal?.AssetName;
    AssetTotal.PortfolioAbbrev = APIData.AssetsTotal?.PortfolioAbbrev;
    AssetTotal.CurrentPosition = APIData.AssetsTotal?.MarketValue;
    AssetTotal.Weight = APIData.AssetsTotal?.Weight/100;
    AssetTotal.mode = "pinned";
    AssetTotal.TotalorPercetage = "TotalorPecentage";
    APIData?.AssetsTotal?.QuickestRedemptions?.map(item => {
        AssetTotal[item.RedemptionDate + "***" + "Quick"] = item.RedemptionAmount
        AssetTotal[item.RedemptionDate + "***" + "QuickIsBooked"] = item.IsBooked
    });
    APIData?.AssetsTotal?.CheapestRedemptions?.map(item => {
        AssetTotal[item.RedemptionDate + "***" + "Cheap"] = item.RedemptionAmount
        AssetTotal[item.RedemptionDate + "***" + "CheapIsBooked"] = item.IsBooked

    });
    const AssetTotalPre = {}
    AssetTotalPre.StrategyName = ["Total"];
    AssetTotalPre.Strategy = "Total";
    AssetTotalPre.AssetName =  "";
    AssetTotalPre.PortfolioAbbrev = APIData.AssetsTotal?.PortfolioAbbrev;
    AssetTotalPre.CurrentPosition = APIData.AssetsTotal?.MarketValue;
    AssetTotalPre.Weight = APIData.AssetsTotal?.Weight/100;
    AssetTotalPre.mode = "pinned";
    AssetTotalPre.TotalorPercetage = "Percentage";
    APIData?.AssetsTotal?.QuickestRedemptions?.map(item => {
        AssetTotalPre[item.RedemptionDate + "***" + "Quick"] = item.RedemptionAmount
        AssetTotalPre[item.RedemptionDate + "***" + "QuickIsBooked"] = item.IsBooked

    });
    APIData?.AssetsTotal?.CheapestRedemptions?.map(item => {
        AssetTotalPre[item.RedemptionDate + "***" + "Cheap"] = item.RedemptionAmount
        AssetTotalPre[item.RedemptionDate + "***" + "CheapIsBooked"] = item.IsBooked

    });

    const AssetsTotalLiqPercent = {}
    AssetsTotalLiqPercent.StrategyName = ["Percentage by Date"];
    AssetsTotalLiqPercent.Strategy = "Percentage by Date";

    AssetsTotalLiqPercent.AssetName = "";
    AssetsTotalLiqPercent.PortfolioAbbrev = APIData.AssetsTotalLiqPercent?.PortfolioAbbrev;
    AssetsTotalLiqPercent.CurrentPosition = APIData.AssetsTotalLiqPercent?.MarketValue;
    AssetsTotalLiqPercent.Weight = APIData.AssetsTotalLiqPercent?.Weight;
    AssetsTotalLiqPercent.mode = "pinned";
    AssetsTotalLiqPercent.TotalorPercetage = "Percentage";
    APIData?.AssetsTotalLiqPercent?.QuickestRedemptions?.map(item => {
        AssetsTotalLiqPercent[item.RedemptionDate + "***" + "Quick"] = item.RedemptionAmount
        AssetsTotalLiqPercent[item.RedemptionDate + "***" + "QuickIsBooked"] = item.IsBooked
        
    });
    APIData?.AssetsTotalLiqPercent?.CheapestRedemptions?.map(item => {
        AssetsTotalLiqPercent[item.RedemptionDate + "***" + "Cheap"] = item.RedemptionAmount
        AssetsTotalLiqPercent[item.RedemptionDate + "***" + "CheapIsBooked"] = item.IsBooked
        
    });


    const AssetsTotalLiqCummPercent = {}
    AssetsTotalLiqCummPercent.StrategyName = ["Cumulative Percentage"];
    AssetsTotalLiqCummPercent.Strategy = "Cumulative Percentage";
    AssetsTotalLiqCummPercent.AssetName = "";
    AssetsTotalLiqCummPercent.PortfolioAbbrev = APIData.AssetsTotalLiqCummPercent?.PortfolioAbbrev;
    AssetsTotalLiqCummPercent.CurrentPosition = APIData.AssetsTotalLiqCummPercent?.MarketValue;
    AssetsTotalLiqCummPercent.Weight = APIData.AssetsTotalLiqCummPercent?.Weight;
    AssetsTotalLiqCummPercent.mode = "pinned";
    AssetsTotalLiqCummPercent.TotalorPercetage = "Percentage";
    APIData?.AssetsTotalLiqCummPercent?.QuickestRedemptions?.map(item => {
        AssetsTotalLiqCummPercent[item.RedemptionDate + "***" + "Quick"] = item.RedemptionAmount
        AssetsTotalLiqCummPercent[item.RedemptionDate + "***" + "QuickIsBooked"] = item.IsBooked
        
    });
    APIData?.AssetsTotalLiqCummPercent?.CheapestRedemptions?.map(item => {
        AssetsTotalLiqCummPercent[item.RedemptionDate + "***" + "Cheap"] = item.RedemptionAmount
        AssetsTotalLiqCummPercent[item.RedemptionDate + "***" + "CheapIsBooked"] = item.IsBooked
        
    });


    const AssetsTotalLiq = {}
    AssetsTotalLiq.StrategyName = ["Total by Date"];
    AssetsTotalLiq.Strategy = "Total by Date";
    AssetsTotalLiq.AssetName = "";
    AssetsTotalLiq.PortfolioAbbrev = APIData.AssetsTotalLiq?.PortfolioAbbrev;
    AssetsTotalLiq.CurrentPosition = APIData.AssetsTotalLiq?.MarketValue;
    AssetsTotalLiq.Weight = APIData.AssetsTotalLiq?.Weight/100;
    AssetsTotalLiq.mode = "pinned";
    AssetsTotalLiq.TotalorPercetage = "Total";
    APIData?.AssetsTotalLiq?.QuickestRedemptions?.map(item => {
        AssetsTotalLiq[item.RedemptionDate + "***" + "Quick"] = item.RedemptionAmount
        AssetsTotalLiq[item.RedemptionDate + "***" + "QuickIsBooked"] = item.IsBooked
        
    });
    APIData?.AssetsTotalLiq?.CheapestRedemptions?.map(item => {
        AssetsTotalLiq[item.RedemptionDate + "***" + "Cheap"] = item.RedemptionAmount
        AssetsTotalLiq[item.RedemptionDate + "***" + "CheapIsBooked"] = item.IsBooked

    });



    const AssetsTotalLiqCumm = {}
    AssetsTotalLiqCumm.StrategyName = ["Cumulative Total"];
    AssetsTotalLiqCumm.Strategy = "Cumulative Total";
    AssetsTotalLiqCumm.AssetName = "";
    AssetsTotalLiqCumm.PortfolioAbbrev = APIData.AssetsTotalLiqCumm?.PortfolioAbbrev;
    AssetsTotalLiqCumm.CurrentPosition = APIData.AssetsTotalLiqCumm?.MarketValue;
    AssetsTotalLiqCumm.Weight = APIData.AssetsTotalLiqCumm?.Weight;
    AssetsTotalLiqCumm.mode = "pinned";
    AssetsTotalLiqCumm.TotalorPercetage = "Total";
    APIData?.AssetsTotalLiqCumm?.QuickestRedemptions?.map(item => {
        AssetsTotalLiqCumm[item.RedemptionDate + "***" + "Quick"] = item.RedemptionAmount
        AssetsTotalLiqCumm[item.RedemptionDate + "***" + "QuickIsBooked"] = item.IsBooked
        
    });
    APIData?.AssetsTotalLiqCumm?.CheapestRedemptions?.map(item => {
        AssetsTotalLiqCumm[item.RedemptionDate + "***" + "Cheap"] = item.RedemptionAmount
        AssetsTotalLiqCumm[item.RedemptionDate + "***" + "CheapIsBooked"] = item.IsBooked
        
    });
    if(isTreeView)
    return [...formattedAssetLines, ...formattedStrategyLines, AssetTotal, AssetsTotalLiqCumm, AssetsTotalLiq, AssetsTotalLiqCummPercent, AssetsTotalLiqPercent];
    else 
    return [...formattedAssetLines, AssetTotal,  AssetsTotalLiqCumm, AssetsTotalLiq, AssetsTotalLiqCummPercent, AssetsTotalLiqPercent];

};
const getFormattedColumn = (APIData,mode,isTree) => {
    const staticColumns = [
        // {headerName:"Strategy", field:'total' ,pinned: 'left'},
        { headerName: "Strategy", field: "Strategy", pinned: 'left', width: '200px', type: "Static",hide:isTree, pinned: 'left' },
        { headerName: "Asset", field: 'AssetName', pinned: 'left', type: "Static", hide:isTree,pinned: 'left' },
        { headerName: "Portfolio Abbr.", field: 'PortfolioAbbrev', pinned: 'left', width: '100px', type: "Static" },
        {
            headerName: "Current Position",
            field: 'CurrentPosition',
            cellClass: 'currencyFormat',
            valueFormatter: (params) => {
                
                if(params?.data?.mode=="pinned")
                {
                    
                    console.log(params,'params')
                    if(params?.data?.Strategy==="Total" || params?.data?.Strategy==="total")
                    return formatCurrency(params.value)
                    else if(params?.colDef.type==="Static")
                    return ""
                    else if(params.data.TotalorPercetage=="Percentage")
                    return formatPercentage(params.value)
                    else 
                    return formatCurrency(params.value)
                }
                else 
              {
                return formatCurrency(params.value)
              }
            },
            cellStyle: { textAlign: 'right', marginRight: '20px' },
            pinned: 'left',
            width: '130px',
            type: "Static"
        },
        { headerName: "Weight", field: 'Weight', cellClass: 'percentageFormat',
        valueFormatter: (params) => {
            if(params?.data?.mode=="pinned")
            {
                if (params?.data?.Strategy === "Total" || params?.data?.Strategy === "total")
                    return formatPercentage(params.value)
                else if (params?.colDef.type==="Static")
                    return ""
            }
            else 
            return formatPercentage(params.value)
        },
         pinned: 'left', width: '100px', type: "Static" },
    ];

    const quickColDef = APIData?.AssetLiqSchedule[0]?.QuickestRedemptions.map(item => ({
        headerName:!item.IsAggregate ? moment(item.RedemptionDate).format("MM/DD/YYYY") : "Aggregate",
        field: item.RedemptionDate + "***" + "Quick",
        cellStyle:(params)=>({ textAlign: 'right', marginRight: '20px' , fontStyle:params.data[item.RedemptionDate + "***" + "QuickIsBooked"]  ? 'italic' :'unset'}),
        minWidth: 150,
        type: "Dyanmic",
        cellClass: (params) => { if (params?.data?.TotalorPercetage=="Percentage" ) { return "percentageFormat"; } else return "currencyFormat" },
        valueFormatter: (params) => {
            if(params?.data?.mode=="pinned")
            {
                if(params?.data?.Strategy==="Total" || params?.data?.Strategy==="total")
                return formatCurrency(params.value)
                else if(params.data.TotalorPercetage=="Percentage")
                return formatPercentage(params.value)
                else 
                return formatCurrency(params.value)
            }
            else 
          {
            return formatCurrency(params.value)
          }
        },
    })
    );

    
    const cheapColDef = APIData?.AssetLiqSchedule[0]?.CheapestRedemptions.map(item => ({
        headerName:!item.IsAggregate ? moment(item.RedemptionDate).format("MM/DD/YYYY") : "Aggregate",
        field:item.RedemptionDate + "***" + "Cheap",
        cellStyle:(params)=>({ textAlign: 'right', marginRight: '20px' , fontStyle:params.data[item.RedemptionDate + "***" + "CheapIsBooked"]   ? 'italic' :'unset'}),
        minWidth: 150,
        type: "Dyanmic",
        cellClass: (params) => { if (params?.data?.TotalorPercetage=="Percentage"  ) { return "percentageFormat"; } else return "currencyFormat" },
        valueFormatter: (params) => {
            if(params.data.mode=="pinned")
            {
                if(params?.data?.Strategy==="Total" || params?.data?.Strategy==="total")
                return formatCurrency(params.value)
                else if(params.data.TotalorPercetage=="Percentage")
                return formatPercentage(params.value)
                else 
                return formatCurrency(params.value)
            }
            else 
          {
            return formatCurrency(params.value)
          }
        },
    })
    );
    const Quick = {
        headerName: "Quickest",
        children: quickColDef,
        headerClass: "justify-content-center"
    };
    const Cheap = {
        headerName: "Cheapest",
        children: cheapColDef,
        headerClass: "justify-content-center"
    }
    if(mode=="SCH")
    return [...staticColumns, Quick,Cheap]
    else if(mode=="QUICK")
    return [...staticColumns, ...Quick.children]
    else if(mode=="Cheap")
    return [...staticColumns, ...Cheap.children]
    else 
    return []
};
const formatPercentage = (value) => {
    if (value == null) return '';
    if (value) {
        const percentValue = Number(value * 100).toFixed(2);
        return `${percentValue} %`;
    }
    else
        return null;
};
const formatCurrency = (value) => {
    {
        if (value == null) return '';
        if (parseInt(value) == 0) return '';
        return `$${Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }
};